import { Buffer } from "buffer"

export default function toBase64String(str: string): string {
  return Buffer.from(str, "utf8").toString("base64")
}
